import ColorTag from '../ColorTag';

import styles from './index.module.css';

const BADGE_TYPE = {
  freeDelivery: {
    text: '무료배송',
    className: styles.freeDelivery,
  },
};

type Props = {
  type: keyof typeof BADGE_TYPE;
  text?: string;
  className?: string;
};

const ProductBadge = ({ type, text, className }: Props) => {
  return (
    <ColorTag label={text || BADGE_TYPE[type].text} className={className} />
  );
};

export default ProductBadge;
